/* eslint-disable @nx/enforce-module-boundaries */
import { HStack, ListItem } from "@mybridge/ui";

export const DiskTypeMenuItem = (props) => {
  return (
    <HStack
      cursor="pointer"
      p={[1,2]}
      role="group"
      borderRadius="full"
      _hover={{ bg: 'brandGray.500' }}
      {...(props ?? {})}
    />
  );
};

export const DiskMenuItem = (props) => {
  return (
    <ListItem
      as={HStack}
      cursor="pointer"
      p={[1,2]}
      role="group"
      borderRadius="full"
      _hover={{ bg: 'brandGray.500' }}
      {...(props ?? {})}
    />
  );
};

export const DiskTypeMenuItemIcon = (props) => {
  return (
    <HStack
      justifyContent="center"
      alignItems="center"
      p={2}
      h='30.75px'
      w="30.75px"
      borderRadius="full"
      bg="brandPrimary.500"
      {...(props ?? {})}
    />
  );
};

export const DiskMenuItemIcon = (props) => {
  return (
    <HStack
      justifyContent="center"
      alignItems="center"
      p={2}
      borderRadius="full"
      bg="brandGray.500"
      {...(props ?? {})}
    />
  );
};
